<template>
  <div>
    <div v-for="(group, index) in groupedComments" :key="`group${index}`">
      <FocusComment
        v-for="comment in group"
        :key="comment.id"
        v-bind="comment" />
    </div>
  </div>
</template>

<script>
import FocusComment from './FocusComment'
import moment from 'moment'
import orderBy from 'lodash/orderBy'

export default {
  components: {
    FocusComment
  },
  props: {
    comments: Array
  },
  computed: {
    sortedComments () {
      return orderBy(this.comments, [(comment) => moment(comment.date).valueOf()], ['desc'])
    },
    groupedComments () {
      const groupedComments = []

      this.sortedComments.forEach((sortedComment) => {
        let groupedIndex = null

        groupedComments.every((commentsArray, index) => {
          const isSameActivity = commentsArray[0].activity.id === sortedComment.activity.id

          if (isSameActivity) {
            groupedIndex = index
            return false
          } else {
            return true
          }
        })

        if (groupedIndex !== null) {
          groupedComments[groupedIndex].push(sortedComment)
        } else {
          groupedComments.push([sortedComment])
        }
      })

      return groupedComments
    }
  }
}
</script>



// WEBPACK FOOTER //
// FocusComments.vue?fbd79186